"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "Card__Container",
  componentId: "sc-th8a7m-0"
})(["background:", ";border-radius:4px;box-shadow:0 3px 5px rgba(52,62,71,0.12);padding:", ";width:100%;"], function (props) {
  return props.bgColor || '#fff';
}, function (props) {
  return props.padding;
});

var Card = function Card(props) {
  return /*#__PURE__*/_react.default.createElement(Container, props);
};

var _default = Card;
exports.default = _default;